/**
 * v5 — Helpers pour les informations client (fidélité, etc.)
 */

/**
 * Formate un numéro de téléphone avant envoi à l'API.
 *
 * Règles :
 * - Retire espaces, points, tirets, parenthèses
 * - Si commence par "+33" → retire et préfixe par "0"
 *   ex: "+33 6 12 34 56 78"  → "0612345678"
 *       "06 12 34 56 78"     → "0612345678"
 *       "06-12-34-56-78"     → "0612345678"
 * - Si juste "+33" ou vide → retourne "" (jamais envoyer juste "+33")
 *
 * Le country_phone_code "+33" est stocké séparément dans user_details.
 */
export function formatCustomerPhone(rawPhone: string | null | undefined): string {
  if (!rawPhone) return '';

  // Nettoyer : retirer espaces, points, tirets, parenthèses
  let cleaned = rawPhone.replace(/[\s.\-()]/g, '');

  // Si commence par +33 → retirer et préfixer par 0
  if (cleaned.startsWith('+33')) {
    cleaned = '0' + cleaned.slice(3);
  } else if (cleaned.startsWith('0033')) {
    cleaned = '0' + cleaned.slice(4);
  }

  // Garde-fous : trop court ou juste un préfixe → vide
  if (cleaned.length < 5) return '';

  return cleaned;
}

/**
 * Vérifie qu'un numéro saisi est plausible (ni vide, ni trop court).
 * Sert pour l'UI : on désactive le bouton "valider" si invalide.
 */
export function isPhonePlausible(rawPhone: string | null | undefined): boolean {
  const formatted = formatCustomerPhone(rawPhone);
  // Numéro français : 10 chiffres commençant par 0
  return /^0\d{9}$/.test(formatted);
}
